export default "/_next/static/images/2023-2x-8c1898b20798b1feaa94a9ded20abebf.png";